import { render, staticRenderFns } from "./CreateLessonAllocation.vue?vue&type=template&id=e2812e6c&scoped=true"
import script from "./CreateLessonAllocation.vue?vue&type=script&lang=js"
export * from "./CreateLessonAllocation.vue?vue&type=script&lang=js"
import style0 from "./CreateLessonAllocation.vue?vue&type=style&index=0&id=e2812e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2812e6c",
  null
  
)

export default component.exports